<template>
  <div :classes="classes">
    <div class="d-flex"
         :class="{'flex-row justify-content-start align-items-end': layout === 'horizontal', 'flex-column':  layout === 'vertical'}">
      <ks-data-form :dataProvider="dataProvider" :ref="dataProvider + '_form'" :autocomplete="autocomplete">
        <template #body="{record, dataProvider}">
          <div v-for="input in inputs">
            <ks-input-field :dataSource="input.dataSource" :label="input.label" :type="input.type ? input.type : 'text'"
                            :placeholder="input.placeholder"/>
          </div>
        </template>
      </ks-data-form>
      <div class="mb-2">
        <ks-data-navigation-form :dataProvider="dataProvider" :showSave="true" :showCancel="true" @onSave="saved"
                            @onCancel="cancelled" :labelSave="labelSave"/>
      </div>
    </div>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: 'ks-form',
  mixins: [checkPermissions],
  props: {
    labelSave: {
      type: String,
      default: "Save"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    inputs: {
      type: Array,
      default() {
        return []
        /*Example:
        * [
        *   {'dataSource':'name'},
        *   {'label':'Name'}
        * ]
        * */
      }
    },
    dataProvider: {
      required: true,
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    layout: {
      type: String,
      default: 'horizontal'
    },
    recordId: {
      type: Number,
      default: null
    },
    campaign_id: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: null
    },
  },
  methods: {
    saved(result) {
      this.$emit('onSave', result);
    },
    cancelled() {
      this.$emit('onCancel');
    }
  },
  watch: {
    'inputs': function (value) {
      if (value && this.recordId) {
        app.dataproviders[this.dataProvider].readRecord(this.campaign_id, this.recordId);
        this.inputs.forEach(input => {
          if (input.value || input.value === 0) {
            app.dataproviders[this.dataProvider].record[input.dataSource] = input.value;
          }
        })
      }
    },
  },
  computed: {},
  mounted() {
  },
  data() {
    return {}
  }
}
</script>
